interface Props {
  title: string;
  icon: any;
  showRedBar?: boolean;
}

export function SectionHeadingTitle(props: Props) {
  const Icon = props.icon;
  const { showRedBar = false } = props;

  return (
    <div className="p-2 justify-start items-center gap-2 inline-flex">
      {showRedBar && <div className="w-[3px] h-4 bg-[#cd0241] rounded-full" />}
      {Icon && <Icon className="size-6 text-primary" />}
      <h2 className="text-primary text-sm font-bold">
        {props.title}
      </h2>
    </div>
  );
}

export function SectionNormalTitle(props: Props) {
  const Icon = props.icon;

  return (
    <div className="p-2 justify-start items-center gap-2 inline-flex">
      <Icon className="size-6 text-primary" />
      <span className="text-primary text-sm font-bold">
        {props.title}
      </span>
    </div>
  );
}


export function SectionTitleSkeleton() {
  return (
    <div className="p-2 justify-start items-center gap-2 inline-flex">
      <div className="bg-gray-secondary rounded-full h-6 w-5" />
      <div className="bg-gray-secondary rounded-full h-6 w-52" />
    </div>
  );
}
